import { Menu, Typography } from 'antd';

const { Item } = Menu;
const { Text } = Typography;
// Define colors for styling
const defaultIconColor = '#8C8C8C'; // Gray
const selectedIconColor = '#00A85A'; // Dark Green
const selectedTextColor = '#00A85A'; // Dark Green
const selectedBgColor = '#E6F7EE'; // Light Green
const WebChatSiderFilter = ({ Icon, name, isSelected, onClick }) => {
  return (
    <Item
      icon={
        Icon && (
          <Icon color={isSelected ? selectedIconColor : defaultIconColor} />
        )
      }
      className="hover:bg-gray-200"
      onClick={onClick}
      style={{
        backgroundColor: isSelected && selectedBgColor,
        borderRadius: '6px',
        margin: '4px 0',
        paddingLeft: '1.5rem',
      }}
    >
      <Text
        style={{
          color: isSelected ? selectedTextColor : 'inherit',
        }}
        className="text-gray-500 group-hover:text-black text-xs ms-3"
      >
        {name}
      </Text>
    </Item>
  );
};

export default WebChatSiderFilter;
